
var ski_length_calculator = function(height, weight, level, style, purpose) {

  var result = 0;
  if (weight < 102) {
    result = parseFloat(height) - (102-weight)/10;
  } else {
    result = (weight-102)/10 + parseFloat(height);
  }

  if (level === "B") {
    result = result - 17;
  } else if (level === "I") {
    result = result - 13;
  } else if (level === "A") {
    result = result - 9;
  } else if (level === "E") {
    result = result - 7;
  }

  if (style === "easy-going") {
    result = result - 2;
  } else if (style === "aggressive") {
    result = result + 2;
  }

  if (purpose === "All-Mountain") {
    result = result + 2;
  } else if (purpose === "Groomers and carving") {
    result = result - 2;
  } else if (purpose === "Powder") {
    result = result + 3;
  } else if (purpose === "Touring") {
    result = result + 3;
  } else if (purpose === "Racing") {
    result = result + 7;
  } else if (purpose === "Terrain park") {
    result = result - 3;
  }

  return Math.round(result);
}


module.exports.calculate = ski_length_calculator;
